export default {
      id: "ic_info_exclamation-usage",
      viewBox: "0 0 20 19",
      url: "/" + "images/icons.3.109.2.svg#ic_info_exclamation-usage",
      toString: function () {
        return this.url;
      }
    }